'use client';

import { ALPHABET } from '@/constants';
import styles from '@/styles/jobs-az.module.css';
import { AZJobs } from '@/types/az-jobs';
import Link from '@/components/link-with-utms';
import { useEffect, useState } from 'react';
import { formatJobTitle } from '@/utils/format-job-title';

interface JobsProps {
  jobsAZ: any;
  redirect?: boolean;
  letter?: string;
  renderLinkAllJobs?: boolean;
  maxItemsByLetter?: number;
}

export default function Jobs(props: JobsProps) {
  const {
    letter: propsLetter = `a`,
    jobsAZ,
    redirect = false,
    renderLinkAllJobs = false,
    maxItemsByLetter = undefined,
  } = props;

  const [letterSelected, setLetterSelected] = useState<string>(propsLetter.toUpperCase());

  useEffect(() => {
    setLetterSelected(propsLetter.toUpperCase());
  }, [propsLetter]);

  function hasJobsForTheLetter(letter: string) {
    return jobsAZ.hasOwnProperty(letter);
  }

  return (
    <div className={styles.jobs}>
      <div className="container">
        <div className="col-12 d-flex flex-column align-items-center">
          <h2>Empregos de A-Z</h2>
          <div className={styles.jobs_buttons}>
            <ul className="d-flex align-items-center justify-content-between">
              {ALPHABET.map((letter, index) => {
                let className = `btn btn-white`;
                const disabled = !hasJobsForTheLetter(letter);

                if (letter === letterSelected) {
                  className += ` selected`;
                }

                if (disabled) {
                  className += ` disabled`;
                }
                return (
                  <li key={`az-btn-${letter}-${index}`}>
                    {redirect ? (
                      <Link
                        href={`/vagas/vagas-az/${letter.toLowerCase()}`}
                        scroll={false}
                        key={index}
                        className={className}
                      >
                        {letter}
                      </Link>
                    ) : (
                      <button
                        key={index}
                        className={className}
                        disabled={disabled}
                        onClick={() => setLetterSelected(letter)}
                      >
                        {letter}
                      </button>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
          <div className={styles.jobs_list}>
            {jobsAZ[letterSelected] ? (
              jobsAZ[letterSelected].slice(0, maxItemsByLetter).map((job: AZJobs, index: number) => (
                <Link
                  key={index + job.roleTitle}
                  href={`/vagas/cargo/${job.roleCode}-${job.roleTitleSlug}`}
                  className={styles.jobs_item}
                >
                  <span className={styles.role_title}>{formatJobTitle(job.roleTitle)}</span>
                  <span>{job.jobAmount}</span>
                </Link>
              ))
            ) : (
              <p>Não há vagas de emprego com a letra {letterSelected}</p>
            )}
          </div>
          {renderLinkAllJobs && (
            <Link
              href={`/vagas/vagas-az/${letterSelected.toLowerCase()}`}
              className="btn btn-secondary btn-medium btn-all-job"
            >
              Ver todas as vagas
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
